import React from 'react'

let skills = [
  {
    profileWords: "Hi , i m Hafeez"
  },
  {
    profileWords: "Application Developer"
  }
]

export default skills